const LICENSE_DETAILS_PANEL_CONSTANTS = {
  PERCENT: '%',
  APOSTROPHE: "'",
} as const;

export default LICENSE_DETAILS_PANEL_CONSTANTS;
